<template>
  <div class="resident-list">
    <section class="list-header">
      <div class="title-row">
        <v-btn icon class="back-button" @click="$router.push('/home')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h1>Encomendas</h1>
      </div>
      <v-btn icon class="refresh-button" @click="load">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </section>

    <section v-if="!items.length && !loading" class="empty-panel">
      <v-icon color="primary" size="36">mdi-package-variant-closed</v-icon>
      <strong>Nenhuma encomenda aguardando</strong>
      <span>Quando a portaria receber algo para sua residência, aparecerá aqui.</span>
    </section>

    <article v-for="item in items" :key="item.id" class="package-card">
      <div class="package-icon">
        <v-icon color="primary">mdi-package-variant-closed</v-icon>
      </div>
      <div class="package-body">
        <strong>{{ item.carrier || item.package_type || "Encomenda" }}</strong>
        <span>{{ item.tracking_code || item.notes || "Retire na portaria" }}</span>
        <small>Recebida em {{ shortDateTime(item.received_at) }}</small>
      </div>
      <v-chip x-small :color="item.status === 'picked_up' ? 'secondary' : 'primary'" :text-color="item.status === 'picked_up' ? 'primary' : 'white'">
        {{ statusLabel(item.status) }}
      </v-chip>
    </article>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BoaruaPackages",
  data() {
    return {
      loading: false,
      items: [],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      const profile = JSON.parse(localStorage.getItem("associationProfile") || "{}");
      if (!profile.tenant_id) return;
      this.loading = true;
      try {
        const response = await axios.get("/packages", {
          params: { tenant_id: profile.tenant_id, limit: 50 },
        });
        this.items = response.data.content.data || response.data.content || [];
      } finally {
        this.loading = false;
      }
    },
    statusLabel(status) {
      const labels = { received: "Recebida", notified: "Avisada", picked_up: "Retirada" };
      return labels[status] || status || "Recebida";
    },
    shortDateTime(value) {
      if (!value) return "sem data";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "sem data";
      return date.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
    },
  },
};
</script>

<style scoped lang="scss">
.resident-list {
  min-height: 100%;
  padding: 0 16px 18px;
  color: #111827;
}

.list-header {
  min-height: 72px;
  margin: 0 -16px 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  border-bottom: 1px solid #edf0ed;

  h1 {
    margin: 0;
    font-size: 24px;
  }
}

.title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.back-button,
.refresh-button {
  background: #f5f7f5;
  border: 1px solid #dfe7df;
  border-radius: 12px;
}

.package-card,
.empty-panel {
  background: #ffffff;
  border: 1px solid #e1e8e2;
  border-radius: 16px;
}

.package-card {
  min-height: 90px;
  margin-bottom: 10px;
  padding: 13px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.package-icon {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef7f1;
  border-radius: 12px;
}

.package-body {
  flex: 1;
  min-width: 0;

  strong,
  span,
  small {
    display: block;
  }

  span,
  small {
    color: #66736b;
    font-size: 12px;
  }
}

.empty-panel {
  min-height: 220px;
  padding: 22px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  text-align: center;

  span {
    color: #66736b;
    font-size: 13px;
  }
}
</style>
